import styled from 'styled-components';

export const FormGroupWrapper = styled.div`
  width: 100%;
  margin-bottom: ${props => (props.noMargin ? 0 : 30)}px;
`;

export const CheckboxsWrapper = styled.div`
  display: ${props => (props.inline ? 'flex' : 'block')};
  & > :not(:first-child) {
    margin-left: ${props => (props.inline ? 10 : 0)}px;
  }
`;

export const SubLabel = styled.p`
  margin: -5px 0 10px 27px;
  color: ${props => props.theme.colors.black};
  font-family: ${props => props.theme.fonts.literata};
  font-size: 14px;
  line-height: 20px;

  opacity: ${props => (props.disabled ? 0.3 : 1)};
`;
